import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { DictionaryRecord, useDictionaries } from '../../toolympus/hooks/useDictionaries';
import { Chip } from '@mui/material';
import { getContrastTextColorSimple } from './ProjectStateDisplay';

interface Props {
  value?: string[] | null;
  condensed?: boolean;
}

export const SupportDisplay = (props: Props) => {
  const { value } = props;

  const dicts = useDictionaries();
  const dict = dicts["ProjectSupportActors"];

  const selected = useMemo(() => {
    return (value || []).map(v => dict.records.find(r => r.code === v)).filter(x => !!x) as DictionaryRecord[];
  }, [dict.records, value])

  return (<>
    {selected.map(r => (
      props.condensed
        ? (
          <CondensedChip
            style={{ background: r?.extra?.color, color: getContrastTextColorSimple(r?.extra?.color) }}
            >
            {r.label.substring(0,1)}
          </CondensedChip>
        )
        : (
          <Chip
            size="small"
            label={r?.label || "..."}
            sx={{ background: r?.extra?.color, color: getContrastTextColorSimple(r?.extra?.color) }}
            />
        )
    ))}
  </>);
}

const CondensedChip = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  min-width: 20px;
  text-transform: uppercase;

  text-align: center;
  padding: 2px 0;
  font-size: 0.75rem;

  & + & {
    margin-left: 2px;
  }
`;